import axios from 'axios';

export default {
  getCartDataForView,
  addToCart,
  updateItemQty,
  updateItemSubscription,
  removeFromCart,
  loadPromoById,
  applyCoupon,
  removeCoupon,
  applyPromo,
  validatePromoById,
  getPreOrderId,
  cancelPreOrder,
  moveToOtherCart,
  shipRefillWithCart
};

export function getCartDataForView(params) {
  return axios.get('/api/cart/getCartDataForView', { params });
}

export function addToCart(params) {
  return axios.post('/api/cart/addToCart', params);
}

export function updateItemQty(params) {
  return axios.post('/api/cart/updateItemQty', params);
}

export function updateItemSubscription(params) {
  return axios.post('/api/cart/updateItemSubscription', params);
}

export function removeFromCart(params) {
  return axios.post('/api/cart/removeItemFromCart', params);
}

export function loadPromoById(params) {
  return axios.get('/api/promo/loadById', { params });
}

export function applyCoupon(params) {
  return axios.post('/api/cart/applyCoupon', params);
}

export function removeCoupon(params) {
  return axios.post('/api/cart/removeCoupon', params);
}

export function applyPromo(params) {
  return axios.post('/api/cart/applyPromo', params);
}

export function validatePromoById(params) {
  return axios.get('/api/cart/validatePromoById', { params });
}

export function getPreOrderId(params) {
  return axios.get('/api/preOrder/getPreOrderId', { params });
}

export function cancelPreOrder(params) {
  return axios.post('/api/preOrder/cancelPreOrder', params);
}

export function moveToOtherCart(params) {
  return axios.post('/api/cart/moveToOtherCart', params);
}

export function shipRefillWithCart(params) {
  return axios.post('/api/cart/shipRefillWithCart', params);
}
